// ANCHOR React
import * as React from 'react';

// ANCHOR Base
import { Button } from 'baseui/button';

// ANCHOR Models
import { useSignInVisibilityShow } from '@lyon/nodes/global/sign-in-visibility-node';

// ANCOR Styles
import { BUTTON } from './styles';

// ANCHOR Constants
import { BUTTON_CONTENT } from './constants';

export const LyonRestrictedLink = React.memo(() => {
  const show = useSignInVisibilityShow();

  return (
    <Button overrides={BUTTON} onClick={show}>
      {BUTTON_CONTENT}
    </Button>
  );
});
